import { ClientProxy } from '../../base/proxy/clientProxy'
import { buildFeedbackPayload } from './messageFeedback'
import { ChatMessageRequest, FeedbackVote } from './types'

// Mevcut ClientProxy desenini (auth header'ları otomatik) yeniden kullanır.

export class ChatMessageApi extends ClientProxy {
  constructor() {
    super({ url: 'chat/message' })
  }

  public async send(request: ChatMessageRequest): Promise<unknown> {
    return await this.postAsync<unknown>(request)
  }
}

export class ChatButtonsApi extends ClientProxy {
  constructor() {
    super({ url: 'chat/buttons' })
  }

  public async list(): Promise<unknown> {
    return await this.getAsync<unknown>()
  }
}

export class ChatCompanyListApi extends ClientProxy {
  constructor() {
    super({ url: 'homepage/company-list' })
  }

  public async list(): Promise<unknown> {
    return await this.getAsync<unknown>()
  }
}

export class ChatHistoryApi extends ClientProxy {
  constructor() {
    super({ url: 'chat/conversations' })
  }

  public async list(): Promise<unknown> {
    // days gönderilmez: görünür pencere sunucu kararıdır (VisibleDays).
    return await this.getAsync<unknown>()
  }
}

export class ChatHistoryMessagesApi extends ClientProxy {
  constructor(conversationId: number) {
    super({ url: `chat/conversations/${conversationId}/messages` })
  }

  public async list(): Promise<unknown> {
    return await this.getAsync<unknown>()
  }
}

export class ChatHistoryDeleteApi extends ClientProxy {
  constructor() {
    super({ url: 'chat/conversations' })
  }

  public async remove(conversationId: number): Promise<unknown> {
    return await this.deleteAsync<unknown>(String(conversationId))
  }
}

/**
 * Yanıt geri bildirimi (ADR-015). Bayi/kullanıcı kimliği GÖNDERİLMEZ — kapsam oturumdan gelir.
 * `reasonCode` kapalı kümedendir; `comment` en fazla 500 karakterlik isteğe bağlı nottur. İkisi de
 * yalnız olumsuz oyda gövdeye girer (bkz. `buildFeedbackPayload`).
 */
export class ChatFeedbackApi extends ClientProxy {
  constructor(messageId: number) {
    super({ url: `chat/messages/${messageId}/feedback` })
  }

  public async submit(vote: FeedbackVote, reasonCode?: string, comment?: string): Promise<unknown> {
    return await this.postAsync<unknown>(buildFeedbackPayload(vote, reasonCode, comment))
  }
}

/**
 * Bayinin HENÜZ cevaplamadığı, tarihi geçerli ve kendisine hedeflenmiş anket soruları. Hedefleme
 * (bayi kodu / tip / alt tip) sunucuda yapılır; widget yalnız davet balonunu göstermeye karar verir.
 */
export class ChatPendingSurveyApi extends ClientProxy {
  constructor() {
    super({ url: 'survey/list' })
  }

  public async list(): Promise<unknown> {
    return await this.getAsync<unknown>()
  }
}
